import { render, staticRenderFns } from "./container-item-wrapper.vue?vue&type=template&id=dc0f89b6&scoped=true"
import script from "./container-item-wrapper.vue?vue&type=script&lang=js"
export * from "./container-item-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0f89b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc0f89b6')) {
      api.createRecord('dc0f89b6', component.options)
    } else {
      api.reload('dc0f89b6', component.options)
    }
    module.hot.accept("./container-item-wrapper.vue?vue&type=template&id=dc0f89b6&scoped=true", function () {
      api.rerender('dc0f89b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-render/container-item/container-item-wrapper.vue"
export default component.exports